<template>
<div class="form-group" :class="[{ 'coff-input-error' : error }]" :key="uuid">

    <label htmlFor="input">
        <b>{{$t(label, additionalTranslate)}}</b>
        <slot name="label"></slot>
    </label>

    <div class="input-group">
        <input :key="uuid" v-money="config" v-model="modelValue" type="text" :class="[{ 'p-error' : error }]" class="p-inputtext p-component p-filled" style="width: 100%" />
        <span v-if="error">{{ $t(errorMessage)}}</span>
    </div>

</div>
</template>

<script>
    import Utils from "@/utils/Utils";

    export default {
        name: "CoffMoneyInput",

        props:{
            value: null,
            label: {type: String, default: null},
            error: {type: Boolean, default: false},
            errorMessage: {type: String, default: 'field.default.error'},
            id: null,
            disable: {type: Boolean, default: false},
            additionalTranslate: {type: Object, default: () => {}},
            minFractionDigits: {type: Number, default: 2},
        },

        data(){
            return {
                uuid: Utils.uuid(),
                config: {
                    decimal: ',',
                    thousands: '.',
                    precision: this.minFractionDigits,
                    masked: false,
                },
            }
        },

        mounted() {
            if(this.id){
                this.uuid = this.id;
            }
        },
        computed: { 
            modelValue: {
                get() {
                    return this.value;
                },
                set(val) {
                    this.$emit('input', val);
                }
            }
        }

    }
</script>

<style scoped>

</style>
